import styled from 'styled-components';

export const TextButton = styled.span`
  display: block;
  padding: 6px 10px;
`;
